import type React from "react"
import type { ChangeEvent } from "react"
import { Component } from "react"
import ReactTooltip from "react-tooltip"

import CLASSES from "../constants/classes"
import type { ISettingsElement } from "../constants/interfaces"

interface MyProps {
    settings: Array<ISettingsElement>
    updateSettings: (fieldKey: string, fieldValue: number) => void
}

interface MyState {
    show: boolean
    tooltipText: string | React.ReactElement
}

export default class Settings extends Component<MyProps, MyState> {
    /**
     * A small settings menu to enable and disable things
     * And to be able to adjust certain sizes
     */
    constructor(props: MyProps) {
        super(props)
        this.state = {
            show: false,
            tooltipText: "",
        }
    }

    showSettings = (_e: React.MouseEvent<HTMLDivElement, MouseEvent>): void => {
        this.setState({
            show: true,
        })
    }

    hideSettings = (_e: React.MouseEvent<HTMLDivElement, MouseEvent>): void => {
        this.setState({
            show: false,
        })
    }

    onChange = (e: ChangeEvent<HTMLInputElement>, itemShortName: string): void => {
        const newValue = parseFloat(e.target.value)
        this.props.updateSettings(itemShortName, newValue)
    }

    onMouseEnter = (_e: React.MouseEvent<HTMLDivElement, MouseEvent>, item: React.ReactElement): void => {
        this.setState({
            tooltipText: item,
        })
    }

    render(): React.ReactElement {
        const classes = CLASSES.dropDown
        const classesDropdown = this.state.show ? `visible ${classes}` : `hidden ${classes}`

        const settingsElements = this.props.settings.map((item, _index) => {
            const mouseEnterFunc = (e: React.MouseEvent<HTMLDivElement, MouseEvent>) => {
                this.onMouseEnter(e, <div>{item.tooltip}</div>)
            }
            return (
                <div key={item.n} className={CLASSES.dropDownContainer}>
                    {/* biome-ignore lint/a11y/useSemanticElements: Dropdown label triggers tooltip on hover, not a button */}
                    <div
                        role="button"
                        tabIndex={0}
                        className={CLASSES.dropDownLabel}
                        data-tip
                        data-for="settingsTooltip"
                        onMouseEnter={mouseEnterFunc}
                    >
                        {item.name}
                    </div>
                    <input
                        className={CLASSES.dropDownInput}
                        type="number"
                        placeholder={`${item.v}`}
                        defaultValue={item.v}
                        step={item.step}
                        min={item.min}
                        max={item.max}
                        onChange={(e) => {
                            this.onChange(e, item.n)
                        }}
                    />
                </div>
            )
        })

        // TODO Add apply button because onChange doesnt work reliably (laggy behavior)

        const settingsButton = (
            /* biome-ignore lint/a11y/useSemanticElements: Dropdown container shows/hides on hover, not a button */
            <div
                role="button"
                tabIndex={0}
                className={CLASSES.buttons}
                onMouseEnter={this.showSettings}
                onMouseLeave={this.hideSettings}
            >
                Settings
                <div className={classesDropdown}>{settingsElements}</div>
            </div>
        )
        return (
            <div>
                <ReactTooltip place="bottom" id="settingsTooltip" className="max-w-xs">
                    {this.state.tooltipText}
                </ReactTooltip>
                {settingsButton}
            </div>
        )
    }
}
